/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVersionPolicy200ResponseApp
 */
export interface GetVersionPolicy200ResponseApp {
    /**
     * 
     * @type {string}
     * @memberof GetVersionPolicy200ResponseApp
     */
    deprecatedVersion: string;
}

/**
 * Check if a given object implements the GetVersionPolicy200ResponseApp interface.
 */
export function instanceOfGetVersionPolicy200ResponseApp(value: object): value is GetVersionPolicy200ResponseApp {
    if (!('deprecatedVersion' in value) || value['deprecatedVersion'] === undefined) return false;
    return true;
}

export function GetVersionPolicy200ResponseAppFromJSON(json: any): GetVersionPolicy200ResponseApp {
    return GetVersionPolicy200ResponseAppFromJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionPolicy200ResponseApp {
    if (json == null) {
        return json;
    }
    return {
        
        'deprecatedVersion': json['deprecatedVersion'],
    };
}

export function GetVersionPolicy200ResponseAppToJSON(json: any): GetVersionPolicy200ResponseApp {
    return GetVersionPolicy200ResponseAppToJSONTyped(json, false);
}

export function GetVersionPolicy200ResponseAppToJSONTyped(value?: GetVersionPolicy200ResponseApp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deprecatedVersion': value['deprecatedVersion'],
    };
}

